module.exports = __webpack_public_path__ + "static/img/commodity_size2.ac48f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/commodity_size2.png
// module id = oOak
// module chunks = 128